// extracted by css-extract-rspack-plugin
export default {"dimensionPicker":"DimensionsWidget-module__dimensionPicker___vGJHU"};